import {useEffect} from 'react';

export type CalltechCallInfo = {
    phone?: string;
    queue?: string;
    chainId?: string;
    commutationId?: string;
    originalDN?: string;
    platformId?: string;
    direction?: string;
    accessToken?: string;
    app?: {
        permissions: Record<string, unknown>;
    };
    mockPhone?: {
        phone?: string;
    };
};

export type CalltechCall = {
    isEnded?: boolean;
    isMuted?: boolean;
    isOutgoing?: boolean;
    onHold?: boolean;
    info: CalltechCallInfo;
};

type CalltechMessageData = {
    args?: Array<{
        call?: CalltechCall;
    }>;
};

type UseCalltechBridgeParams = {
    calltechHost: string | null;
    phone?: string;
    onCall: (call: CalltechCall) => void;
};

const GET_STATE_MESSAGE = {calltech: 'v1', method: 'getState', args: []};

export const useCalltechBridge = ({calltechHost, phone, onCall}: UseCalltechBridgeParams) => {
    useEffect(() => {
        if (!calltechHost) {
            return;
        }

        const handleCalltechMessage = (event: MessageEvent<CalltechMessageData>) => {
            if (event.origin !== calltechHost) {
                return;
            }

            const lastCall = event.data?.args?.slice(-1)[0]?.call;

            if (!lastCall?.info) {
                return;
            }

            onCall(lastCall);
        };

        window.addEventListener('message', handleCalltechMessage);

        if (window.self === window.top) {
            window.dispatchEvent(new MessageEvent('message', {
                data: {
                    args: [
                        {
                            call: {
                                onHold: false,
                                info: {
                                    phone,
                                    mockPhone: {phone},
                                    app: {
                                        permissions: {},
                                    },
                                },
                            },
                        },
                    ],
                },
                origin: calltechHost,
            }));
        }

        window.parent.postMessage(GET_STATE_MESSAGE, calltechHost);

        return () => {
            window.removeEventListener('message', handleCalltechMessage);
        };
    }, [calltechHost, onCall, phone]);
};
